<template>
  <div class="mobile-task">
    <div v-if="isMobileSession" class="mobile-overlay"></div>

    <QuizModal
      :active="quizModal"
      :options="quizOptions"
      :isMobileApp="true"
      @close="onQuizClose"
      @back="onQuizBack"
      @quizEnd="onQuizEnd"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Cookies from 'js-cookie';
import QuizModal from '@/components/QuizModal/QuizModal.vue';

const TRAINING_PLAN_QUIZ_ID = 101100;

export default {
  name: 'MobileTrainingQuiz',
  components: { QuizModal },
  data() {
    return {
      quizModal: false,
      quizOptions: null,
      finishing: false,
    };
  },
  computed: {
    ...mapGetters('user', ['isMobileApp']),
    isMobileSession() {
      return this.isMobileApp === true || Cookies.get('fromMobileApp') === 'true';
    },
  },
  methods: {
    ...mapActions('user', ['setIsMobileApp']),
    ...mapActions('participant', ['sendTrennings']),
    syncMobileSession() {
      // Для локальной проверки без приложения — считаем сессию мобильной на этом роуте
      Cookies.set('fromMobileApp', 'true', { expires: 365 });
      this.setIsMobileApp({ value: true });

      const tokenFromQuery = this.$route.query.token;
      if (tokenFromQuery) {
        Cookies.set('token', tokenFromQuery, { expires: 365 });
      }
    },
    openQuiz() {
      this.quizOptions = {
        quizId: TRAINING_PLAN_QUIZ_ID,
      };
      this.quizModal = true;
    },
    onQuizClose() {
      this.quizModal = false;
      this.setFinished();
    },
    onQuizBack() {
      this.quizModal = false;
      this.setFinished();
    },
    onQuizEnd(data) {
      // eslint-disable-next-line no-console
      console.log('[MobileTrainingQuiz] onQuizEnd RAW=', data);
      // eslint-disable-next-line no-console
      console.log('[MobileTrainingQuiz] key=', data && data.key);

      if (!data || !data.key) {
        // eslint-disable-next-line no-console
        console.log('[MobileTrainingQuiz] key нет — ждём колбэк с result (пустой emit игнорируем)');
        return;
      }
      if (this.finishing) return;
      this.finishing = true;
      this.quizModal = false;

      // eslint-disable-next-line no-console
      console.log('[MobileTrainingQuiz] POST trainings', data.key);
      this.sendTrennings({ trainingPlan: data.key })
        .finally(() => {
          this.setFinished();
        });
    },
    setFinished() {
      window.location.hash = 'closed';
    },
  },
  mounted() {
    this.syncMobileSession();
    this.openQuiz();
  },
};
</script>

<style lang="scss" scoped>
  @import "./MobileTask";
</style>
